import {TListItem, TTerminalDetails, TTerminalOrder} from './types';
import {getTerminalDetails, getTerminalList} from './mock';
import {TList, TResponse, TUUID} from '@/types';
import faker from '@faker-js/faker';
import CancelablePromise from 'mn-utils/CancelablePromise';
import {apiRequest} from '../../ws';

import {
  ENDPOINT_MERCHANT_TERMINALS_LIST,
  ENDPOINT_MERCHANT_TERMINAL_EDIT,
  ENDPOINT_MERCHANT_TERMINAL_NOTIF,
  ENDPOINT_MERCHANT_TERMINAL_REMOVE,
  ENDPOINT_MERCHANT_TERMINAL_ORDER
} from '../../../constants/api';

export function apiTerminalsList(params: {
  offset: number;
  limit: number;
}): Promise<TList<TListItem[]>> {
  const url = ENDPOINT_MERCHANT_TERMINALS_LIST;
  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 50;

  if (process.env.MOCK) {
    const response = {
      list: getTerminalList(params.limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}

export function apiTerminalsEdit(params: TTerminalDetails): Promise<TResponse> {
  const url = ENDPOINT_MERCHANT_TERMINAL_EDIT;
  params.enabled = params.enabled || false;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}

export function apiTerminalNotificationEmailEdit(params: TTerminalDetails): Promise<TResponse> {
  const url = ENDPOINT_MERCHANT_TERMINAL_NOTIF;
  params.enabled = params.enabled || false;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}

export function apiTerminalsRemove(params: {id: TUUID}): Promise<TResponse> {
  const url = ENDPOINT_MERCHANT_TERMINAL_REMOVE;
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequest(url, params);
}

export function apiV2TerminalsOrder(params: {
  terminals: TTerminalOrder[],
  address?: string,
}): Promise<TResponse> {
  const url = ENDPOINT_MERCHANT_TERMINAL_ORDER;
  if (process.env.MOCK) {
    const response = {id: faker.datatype.uuid()};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequest(url, params);
}
